module.exports = __webpack_public_path__ + "static/media/the-simple-shellfish-frames.f1f50e3e.jpg";